import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "@fetch/axios"
import { useTranslation } from "@hooks/useTranslation";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Spinner from "@components/Spinner";

const RegistroExitoso = () => {
  const MySwal = withReactContent(Swal)
  const { token } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(null)
  const { translate } = useTranslation();
  const continuar = localStorage.getItem('continuar_comprando_arteonu') || 'home';
  const [loading, setLoading] = useState(true)

  useEffect(() => {

    if (token && (!localStorage.getItem('token_arteonu') || JSON.parse(localStorage.getItem('user_arteonu'))?.verified == 0) ) {

      const fetchConfirmation = async () => {

        setLoading(false)
        try {
          const res = await axios.put(
            "/users/complete-register ",
            {
              "token": token,
            }
          );

          setLoading(true)
          if (res.data.errors) {
            MySwal.fire({
              text: res.data.message,
              icon: 'error',
              title: 'Oops...'
            })
          } else {
            let user = {
              "id": res.data.id,
              "name": res.data.name,
              "email": res.data.email,
              "api_token": "64|xvRTz5L9I07hAqVMFkj8mt0WBVRS38p3WAurRYr16232dbc6",
              "phone": res.data.phone,
              "affiliation": res.data.affiliation,
              "verified": 1,
            }
            if(res.data.cart_id){
              localStorage.setItem('cartId', res.data.cart_id)
            }
            localStorage.setItem('token_arteonu', res.data.api_token)
            localStorage.setItem('user_arteonu', JSON.stringify(user));
            localStorage.removeItem('token_volver_crear')
            localStorage.removeItem('email_crear')
            //localStorage.removeItem('continuar_comprando_arteonu')
            setName(res.data.name)
          }

        } catch (error) {
          setLoading(true)
          MySwal.fire({
            text: error.response.data,
            icon: 'error',
            title: 'Oops...'
          })
        }
      }

      fetchConfirmation()
    }

  }, [])

  return (
    <main>
      {!loading && <Spinner />}

      <section className="AgregadoCarrito">
        <div>
          <div className="icon-Check"></div>
          <h3>{translate('login.register_success')}</h3>
          <em>{name ?? ''} {translate('welcome')}</em>
          <div className="ButtonDarkMedium" onClick={() => navigate(continuar)}>
            <i className="icon-Trolley"></i>
            {translate('checkout.continue')}
          </div>
          <div
            className="ButtonLightMedium"
            onClick={() => navigate("/mi-perfil")}
          >
            {translate('view.myprofile.my_profile')}
          </div>
        </div>
      </section>

    </main>
  );
};

export default RegistroExitoso;
